export default "__VITE_ASSET__fc377b24__"